module.exports = __webpack_public_path__ + "img/default-bg-ar.df32b289.png";